import {
    ADAPTIVE_MODE,
    LS_MANUAL_ADAPTIVE_MODE,
} from '../constants';

export function setLsManualAdaptiveMode(manualAdaptiveMode: ADAPTIVE_MODE | null): void {
    manualAdaptiveMode ?
        localStorage.setItem(LS_MANUAL_ADAPTIVE_MODE, manualAdaptiveMode) :
        localStorage.removeItem(LS_MANUAL_ADAPTIVE_MODE);
}
